/*
 * Returns -1 if no match
 */
export const binarySearch = (
  target,
  items,
  cmp: (target, item) => number | null,
  useClosestIndex = false
) => {
  if (!items.length) {
    return -1;
  }

  let midIndex: number;
  let leftIndex = 0;
  let rightIndex: number = items.length - 1;

  // binary search
  // note avoiding recursion to avoid stack overhead
  while (leftIndex <= rightIndex) {
    midIndex = Math.floor((leftIndex + rightIndex) / 2);
    const comp = cmp(target, items[midIndex]);
    if (comp === 0) {
      return midIndex;
    } else if (comp === 1) {
      leftIndex = midIndex + 1;
    } else {
      rightIndex = midIndex - 1;
    }
  }

  if (useClosestIndex) {
    return rightIndex;
  }

  return -1;
};
